"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAlternativeProductIdsMobileUtils = exports.getProductIdUtils = exports.PriceTier = exports.PayloadIAPIdentifierV4 = void 0;
const appPlatform_1 = require("../appPlatform");
const appType_1 = require("../appType");
const language_1 = require("../language");
// Add new topup to the end of the list
var PayloadIAPIdentifierV4;
(function (PayloadIAPIdentifierV4) {
    PayloadIAPIdentifierV4["iapForever10Mins"] = "iapForever10Mins";
    PayloadIAPIdentifierV4["iapForever10MinsDiscounted"] = "iapForever10MinsDiscounted";
    PayloadIAPIdentifierV4["iapForever10MinsDiscounted40"] = "iapForever10MinsDiscounted40";
    PayloadIAPIdentifierV4["iapForever10MinsDiscounted45"] = "iapForever10MinsDiscounted45";
    PayloadIAPIdentifierV4["iapForever10MinsDiscounted50"] = "iapForever10MinsDiscounted50";
    PayloadIAPIdentifierV4["iapForever10MinsDiscounted80"] = "iapForever10MinsDiscounted80";
    PayloadIAPIdentifierV4["iapForever99Mins"] = "iapForever99Mins";
    PayloadIAPIdentifierV4["iapForever99MinsDiscounted"] = "iapForever99MinsDiscounted";
    PayloadIAPIdentifierV4["iapForever99MinsDiscounted40"] = "iapForever99MinsDiscounted40";
    PayloadIAPIdentifierV4["iapForever99MinsDiscounted45"] = "iapForever99MinsDiscounted45";
    PayloadIAPIdentifierV4["iapForever99MinsDiscounted50"] = "iapForever99MinsDiscounted50";
    PayloadIAPIdentifierV4["iapForever99MinsDiscounted80"] = "iapForever99MinsDiscounted80";
    PayloadIAPIdentifierV4["iapForeverAllLanguages"] = "iapForeverAllLanguages";
    PayloadIAPIdentifierV4["iapForeverAllLanguagesDiscounted"] = "iapForeverAllLanguagesDiscounted";
    PayloadIAPIdentifierV4["iapForeverAllLanguagesDiscounted40"] = "iapForeverAllLanguagesDiscounted40";
    PayloadIAPIdentifierV4["iapForeverAllLanguagesDiscounted45"] = "iapForeverAllLanguagesDiscounted45";
    PayloadIAPIdentifierV4["iapForeverAllLanguagesDiscounted50"] = "iapForeverAllLanguagesDiscounted50";
    PayloadIAPIdentifierV4["iapForeverAllLanguagesDiscounted80"] = "iapForeverAllLanguagesDiscounted80";
    PayloadIAPIdentifierV4["iap10MinsMonthly"] = "iap10MinsMonthly";
    PayloadIAPIdentifierV4["iap10MinsYearly"] = "iap10MinsYearly";
    PayloadIAPIdentifierV4["iapUnlimitedMonthly"] = "iapUnlimitedMonthly";
    PayloadIAPIdentifierV4["iapUnlimitedYearly"] = "iapUnlimitedYearly";
    PayloadIAPIdentifierV4["iapAllLanguagesMonthly"] = "iapAllLanguagesMonthly";
    PayloadIAPIdentifierV4["iapAllLanguagesMonthlyFreeTrial"] = "iapAllLanguagesMonthlyFreeTrial";
    PayloadIAPIdentifierV4["iapAllLanguagesYearly"] = "iapAllLanguagesYearly";
    PayloadIAPIdentifierV4["iapUnlimitedMonthlyFreeTrial"] = "iapUnlimitedMonthlyFreeTrial";
    PayloadIAPIdentifierV4["iapPremiumWeekly3"] = "iapPremiumWeekly3";
    PayloadIAPIdentifierV4["iapPremiumWeekly5"] = "iapPremiumWeekly5";
    PayloadIAPIdentifierV4["iapPremiumWeekly7"] = "iapPremiumWeekly7";
    PayloadIAPIdentifierV4["iapPremium2Weekly19FreeTrial7Days"] = "iapPremium2Weekly19FreeTrial7Days";
    PayloadIAPIdentifierV4["iapPremium2Weekly26FreeTrial7Days"] = "iapPremium2Weekly26FreeTrial7Days";
    PayloadIAPIdentifierV4["iapPremiumMonthly3"] = "iapPremiumMonthly3";
    PayloadIAPIdentifierV4["iapPremiumMonthly10"] = "iapPremiumMonthly10";
    PayloadIAPIdentifierV4["iapPremiumMonthly13"] = "iapPremiumMonthly13";
    PayloadIAPIdentifierV4["iapPremiumMonthly15"] = "iapPremiumMonthly15";
    PayloadIAPIdentifierV4["iapPremium3months30"] = "iapPremium3months30";
    PayloadIAPIdentifierV4["iapPremiumQuarterly20"] = "iapPremiumQuarterly20";
    PayloadIAPIdentifierV4["iapPremiumQuarterly30"] = "iapPremiumQuarterly30";
    PayloadIAPIdentifierV4["iapPremium6Monthly40"] = "iapPremium6Monthly40";
    PayloadIAPIdentifierV4["iapPremium1year70"] = "iapPremium1year70";
    PayloadIAPIdentifierV4["iapPremiumYearly70"] = "iapPremiumYearly70";
    PayloadIAPIdentifierV4["iapPremiumYearly70FreeTrial"] = "iapPremiumYearly70FreeTrial";
    PayloadIAPIdentifierV4["iapPremiumYearly70FreeTrial3Days"] = "iapPremiumYearly70FreeTrial3Days";
    PayloadIAPIdentifierV4["iapPremiumYearly70FreeTrial14Days"] = "iapPremiumYearly70FreeTrial14Days";
    PayloadIAPIdentifierV4["iapPremiumYearly55"] = "iapPremiumYearly55";
    PayloadIAPIdentifierV4["iapPremiumYearly50"] = "iapPremiumYearly50";
    PayloadIAPIdentifierV4["iapPremium1year40"] = "iapPremium1year40";
    PayloadIAPIdentifierV4["iapPremiumYearly40"] = "iapPremiumYearly40";
    PayloadIAPIdentifierV4["iapPremiumYearly45"] = "iapPremiumYearly45";
    PayloadIAPIdentifierV4["iapPremiumYearly40FreeTrial"] = "iapPremiumYearly40FreeTrial";
    PayloadIAPIdentifierV4["iapPremiumYearly35"] = "iapPremiumYearly35";
    PayloadIAPIdentifierV4["iapPremiumYearly30"] = "iapPremiumYearly30";
    PayloadIAPIdentifierV4["iapPremiumYearly25"] = "iapPremiumYearly25";
    PayloadIAPIdentifierV4["iapPremiumYearly15"] = "iapPremiumYearly15";
    PayloadIAPIdentifierV4["iapPremiumYearlyEducation"] = "iapPremiumYearlyEducation";
    PayloadIAPIdentifierV4["iapPremiumYearlyKahootPlus"] = "iapPremiumYearlyKahootPlus";
    PayloadIAPIdentifierV4["iapPremiumYearly36FreeTrial7days"] = "iapPremiumYearly36FreeTrial7days";
    PayloadIAPIdentifierV4["iapPremiumYearly42FreeTrial7days"] = "iapPremiumYearly42FreeTrial7days";
    PayloadIAPIdentifierV4["iapPremiumYearly48FreeTrial7days"] = "iapPremiumYearly48FreeTrial7days";
    PayloadIAPIdentifierV4["iapPremiumYearly54FreeTrial7days"] = "iapPremiumYearly54FreeTrial7days";
    PayloadIAPIdentifierV4["iapPremiumYearly56FreeTrial7days"] = "iapPremiumYearly56FreeTrial7days";
    PayloadIAPIdentifierV4["iapPremiumYearly60FreeTrial7days"] = "iapPremiumYearly60FreeTrial7days";
    PayloadIAPIdentifierV4["iapPremiumYearly64FreeTrial7days"] = "iapPremiumYearly64FreeTrial7days";
    PayloadIAPIdentifierV4["iapPremiumYearly70FreeTrial7days"] = "iapPremiumYearly70FreeTrial7days";
    PayloadIAPIdentifierV4["iapPremiumYearly72FreeTrial7days"] = "iapPremiumYearly72FreeTrial7days";
    PayloadIAPIdentifierV4["iapPremiumYearly80FreeTrial7days"] = "iapPremiumYearly80FreeTrial7days";
    PayloadIAPIdentifierV4["iapPremiumYearly90FreeTrial7days"] = "iapPremiumYearly90FreeTrial7days";
    PayloadIAPIdentifierV4["iapPremiumYearly60"] = "iapPremiumYearly60";
    PayloadIAPIdentifierV4["iapPremiumYearly90"] = "iapPremiumYearly90";
    PayloadIAPIdentifierV4["iapPremiumYearly36"] = "iapPremiumYearly36";
    PayloadIAPIdentifierV4["iapPremiumYearly42"] = "iapPremiumYearly42";
    PayloadIAPIdentifierV4["iapPremiumYearly48"] = "iapPremiumYearly48";
    PayloadIAPIdentifierV4["iapPremiumYearly54"] = "iapPremiumYearly54";
    PayloadIAPIdentifierV4["iapPremiumYearly56"] = "iapPremiumYearly56";
    PayloadIAPIdentifierV4["iapPremiumYearly64"] = "iapPremiumYearly64";
    PayloadIAPIdentifierV4["iapPremiumYearly72"] = "iapPremiumYearly72";
    PayloadIAPIdentifierV4["iapPremiumYearly80"] = "iapPremiumYearly80";
    PayloadIAPIdentifierV4["iapPremiumLifetime80"] = "iapPremiumLifetime80";
    PayloadIAPIdentifierV4["iapPremiumLifetime90"] = "iapPremiumLifetime90";
    PayloadIAPIdentifierV4["iapPremiumLifetime55"] = "iapPremiumLifetime55";
    PayloadIAPIdentifierV4["iapPremiumLifetime65"] = "iapPremiumLifetime65";
    PayloadIAPIdentifierV4["iapPremiumLifetime65Plus1Year"] = "iapPremiumLifetime65Plus1Year";
    PayloadIAPIdentifierV4["iapPremiumLifetime35"] = "iapPremiumLifetime35";
    PayloadIAPIdentifierV4["iapPremiumLifetime160"] = "iapPremiumLifetime160";
    PayloadIAPIdentifierV4["iapPremiumLifetime180"] = "iapPremiumLifetime180";
    PayloadIAPIdentifierV4["iapPremiumLifetimeKahootPlus"] = "iapPremiumLifetimeKahootPlus";
    PayloadIAPIdentifierV4["iapPremiumYearly40Plus1"] = "iapPremiumYearly40Plus1";
    PayloadIAPIdentifierV4["iapPremiumYearly40FirstYear15"] = "iapPremiumYearly40FirstYear15";
    PayloadIAPIdentifierV4["iapPremiumYearly40FirstYear30"] = "iapPremiumYearly40FirstYear30";
    PayloadIAPIdentifierV4["iapPremiumYearly40FirstYear30Plus1"] = "iapPremiumYearly40FirstYear30Plus1";
    // gift purchases
    PayloadIAPIdentifierV4["iapPremiumGift1Month10"] = "iapPremiumGift1Month10";
    PayloadIAPIdentifierV4["iapPremiumGift1Year35"] = "iapPremiumGift1Year35";
    PayloadIAPIdentifierV4["iapPremiumGiftLifetime160"] = "iapPremiumGiftLifetime160";
    PayloadIAPIdentifierV4["iapPremiumLifetime55Plus1"] = "iapPremiumLifetime55Plus1";
    // Tiers iaps
    // Full price
    PayloadIAPIdentifierV4["iapPremiumYearlyFullPrice"] = "iapPremiumYearlyFullPrice";
    PayloadIAPIdentifierV4["iapPremiumYearlyFullPriceFreeTrial"] = "iapPremiumYearlyFullPriceFreeTrial";
    PayloadIAPIdentifierV4["iapPremiumYearlyFullPriceFreeTrial14Days"] = "iapPremiumYearlyFullPriceFreeTrial14Days";
    PayloadIAPIdentifierV4["iapPremiumMonthlyFullPrice"] = "iapPremiumMonthlyFullPrice";
    PayloadIAPIdentifierV4["iapPremiumQuarterlyFullPrice"] = "iapPremiumQuarterlyFullPrice";
    PayloadIAPIdentifierV4["iapPremiumLifetimeFullPrice"] = "iapPremiumLifetimeFullPrice";
    // Discount 20%
    PayloadIAPIdentifierV4["iapPremiumYearlyDiscount20"] = "iapPremiumYearlyDiscount20";
    // Discount 40%
    PayloadIAPIdentifierV4["iapPremiumYearlyDiscount40"] = "iapPremiumYearlyDiscount40";
    PayloadIAPIdentifierV4["iapPremiumLifetimeDiscount40"] = "iapPremiumLifetimeDiscount40";
    // Discount 45%
    PayloadIAPIdentifierV4["iapPremiumYearlyDiscount45"] = "iapPremiumYearlyDiscount45";
    PayloadIAPIdentifierV4["iapPremiumLifetimeDiscount45"] = "iapPremiumLifetimeDiscount45";
    // Discount 50%
    PayloadIAPIdentifierV4["iapPremiumYearlyDiscount50"] = "iapPremiumYearlyDiscount50";
    PayloadIAPIdentifierV4["iapPremiumLifetimeDiscount50"] = "iapPremiumLifetimeDiscount50";
    // Discount 55%
    PayloadIAPIdentifierV4["iapPremiumYearlyDiscount55"] = "iapPremiumYearlyDiscount55";
    PayloadIAPIdentifierV4["iapPremiumLifetimeDiscount55"] = "iapPremiumLifetimeDiscount55";
    // Discount 60%
    PayloadIAPIdentifierV4["iapPremiumYearlyDiscount60"] = "iapPremiumYearlyDiscount60";
    PayloadIAPIdentifierV4["iapPremiumLifetimeDiscount60"] = "iapPremiumLifetimeDiscount60";
    // Discount 65%
    PayloadIAPIdentifierV4["iapPremiumYearlyDiscount65"] = "iapPremiumYearlyDiscount65";
    PayloadIAPIdentifierV4["iapPremiumLifetimeDiscount65"] = "iapPremiumLifetimeDiscount65";
    // Lifetime BOGO
    PayloadIAPIdentifierV4["iapPremiumLifetimeDiscount45BOGO"] = "iapPremiumLifetimeDiscount45BOGO";
    // B2B
    PayloadIAPIdentifierV4["iapPremiumOneYearISIC"] = "iapPremiumOneYearISIC";
    PayloadIAPIdentifierV4["iapPremiumOneYearErasmus"] = "iapPremiumOneYearErasmus";
    PayloadIAPIdentifierV4["iapFreePremium2WeeksReferrals"] = "iapFreePremium2WeeksReferrals";
})(PayloadIAPIdentifierV4 = exports.PayloadIAPIdentifierV4 || (exports.PayloadIAPIdentifierV4 = {}));
var PriceTier;
(function (PriceTier) {
    PriceTier["TierA"] = "TierA";
    PriceTier["TierB"] = "TierB";
    PriceTier["TierC"] = "TierC";
    PriceTier["TierD"] = "TierD";
})(PriceTier = exports.PriceTier || (exports.PriceTier = {}));
(function (PriceTier) {
    PriceTier.all = Object.values(PriceTier).filter((v) => typeof v === 'string');
    PriceTier.getPriceTierSuffix = (tier) => {
        switch (tier) {
            case PriceTier.TierA: return 'tier_a';
            case PriceTier.TierB: return 'tier_b';
            case PriceTier.TierC: return 'tier_c';
            case PriceTier.TierD: return 'tier_d';
        }
    };
})(PriceTier = exports.PriceTier || (exports.PriceTier = {}));
const getProductIdUtils = (identifier, platform, appType, tier) => {
    if (platform === appPlatform_1.AppPlatform.Web) {
        return getProductIdWeb(identifier);
    }
    else {
        return getProductIdMobile(identifier, platform, appType, tier);
    }
};
exports.getProductIdUtils = getProductIdUtils;
const getProductIdWeb = (identifier) => {
    switch (identifier) {
        case PayloadIAPIdentifierV4.iapPremiumMonthly10: return '542286';
        case PayloadIAPIdentifierV4.iapPremiumMonthly13: return '590841';
        case PayloadIAPIdentifierV4.iapPremiumMonthly15: return '527451';
        case PayloadIAPIdentifierV4.iapPremiumQuarterly20: return '740626';
        case PayloadIAPIdentifierV4.iapPremiumQuarterly30: return '740625';
        case PayloadIAPIdentifierV4.iapPremium6Monthly40: return '740632';
        case PayloadIAPIdentifierV4.iapPremiumYearly15: return '636504';
        case PayloadIAPIdentifierV4.iapPremiumYearly30: return '563890';
        case PayloadIAPIdentifierV4.iapPremiumYearly35: return '544320';
        case PayloadIAPIdentifierV4.iapPremiumYearly40FirstYear30: return '563890';
        case PayloadIAPIdentifierV4.iapPremiumYearly40FirstYear30Plus1: return '563890';
        case PayloadIAPIdentifierV4.iapPremiumYearly40: return '542307';
        case PayloadIAPIdentifierV4.iapPremiumYearly45: return '593398';
        case PayloadIAPIdentifierV4.iapPremiumYearly50: return '740629';
        case PayloadIAPIdentifierV4.iapPremiumYearly54: return '759310';
        case PayloadIAPIdentifierV4.iapPremiumYearly55: return '753847';
        case PayloadIAPIdentifierV4.iapPremiumYearly60: return '740623';
        case PayloadIAPIdentifierV4.iapPremiumYearly70: return '527452';
        case PayloadIAPIdentifierV4.iapPremiumYearly60FreeTrial7days: return '760793';
        case PayloadIAPIdentifierV4.iapPremiumYearly80FreeTrial7days: return '760794';
        case PayloadIAPIdentifierV4.iapPremiumYearly70FreeTrial: return '591248';
        case PayloadIAPIdentifierV4.iapPremiumYearly90: return '753014';
        case PayloadIAPIdentifierV4.iapPremiumYearly90FreeTrial7days: return '740621';
        case PayloadIAPIdentifierV4.iapPremiumYearlyEducation: return '601126';
        case PayloadIAPIdentifierV4.iapPremiumYearlyKahootPlus: return '650014';
        case PayloadIAPIdentifierV4.iapPremiumLifetime55: return '636592';
        case PayloadIAPIdentifierV4.iapPremiumLifetime65: return '636657';
        case PayloadIAPIdentifierV4.iapPremiumLifetime65Plus1Year: return '636657';
        case PayloadIAPIdentifierV4.iapPremiumLifetime80: return '629966';
        case PayloadIAPIdentifierV4.iapPremiumLifetime160: return '542281';
        case PayloadIAPIdentifierV4.iapPremiumLifetime180: return '590836';
        case PayloadIAPIdentifierV4.iapPremiumGift1Year35: return '575274';
        case PayloadIAPIdentifierV4.iapPremiumGift1Month10: return '575273';
        case PayloadIAPIdentifierV4.iapPremiumGiftLifetime160: return '575271';
        case PayloadIAPIdentifierV4.iapPremiumLifetime90: return '633275';
        case PayloadIAPIdentifierV4.iapPremiumLifetimeKahootPlus: return '650015';
        case PayloadIAPIdentifierV4.iapPremiumWeekly3: return '720363';
        case PayloadIAPIdentifierV4.iapPremiumWeekly5: return '720365';
        case PayloadIAPIdentifierV4.iapPremiumWeekly7: return '720367';
        case PayloadIAPIdentifierV4.iapPremium2Weekly19FreeTrial7Days: return '742625';
        case PayloadIAPIdentifierV4.iapPremium2Weekly26FreeTrial7Days: return '742675';
        case PayloadIAPIdentifierV4.iapPremiumLifetime55Plus1: return '741909';
        case PayloadIAPIdentifierV4.iapPremiumYearly36: return '760783';
        case PayloadIAPIdentifierV4.iapPremiumYearly42: return '760784';
        case PayloadIAPIdentifierV4.iapPremiumYearly48: return '760787';
        case PayloadIAPIdentifierV4.iapPremiumYearly56: return '760789';
        case PayloadIAPIdentifierV4.iapPremiumYearly64: return '760790';
        case PayloadIAPIdentifierV4.iapPremiumYearly72: return '760791';
        case PayloadIAPIdentifierV4.iapPremiumYearly80: return '760792';
        case PayloadIAPIdentifierV4.iapPremiumOneYearISIC: return '796375';
        case PayloadIAPIdentifierV4.iapPremiumOneYearErasmus: return '800184';
        case PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount45BOGO: return '803866';
        case PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount50: return '804116';
        case PayloadIAPIdentifierV4.iapPremiumLifetimeFullPrice: return '804278';
        case PayloadIAPIdentifierV4.iapFreePremium2WeeksReferrals: return `rc_promo_free-premium_weekly`;
        default: return '';
    }
};
const getProductIdMobile = (identifier, platform, appType, tier) => {
    const iapSuffix = appType_1.AppType.getIapSuffix(appType, platform);
    const applePriceMatchSuffix = 'apple_price';
    switch (identifier) {
        case PayloadIAPIdentifierV4.iapForever10Mins:
            if (platform === appPlatform_1.AppPlatform.Android) {
                return `forever_10_mins_${iapSuffix}`;
            }
            switch (appType) {
                case appType_1.AppType.local_hu: return 'drops_topup_forever_10mins_hu';
                case appType_1.AppType.int: return 'drops_topup_forever_5mins';
                default: return `forever_10_mins_${iapSuffix}`;
            }
        case PayloadIAPIdentifierV4.iapForever10MinsDiscounted:
            if (platform === appPlatform_1.AppPlatform.Android) {
                return `forever_10_mins_discounted_60_${iapSuffix}`;
            }
            switch (appType) {
                case appType_1.AppType.local_hu: return 'drops_topup_forever_10mins_discounted_hu';
                case appType_1.AppType.int: return 'drops_topup_forever_10mins_discounted';
                default: return `forever_10_mins_discounted_60_${iapSuffix}`;
            }
        case PayloadIAPIdentifierV4.iapForever10MinsDiscounted40:
            if (platform === appPlatform_1.AppPlatform.Android) {
                switch (appType) {
                    case appType_1.AppType.int: return `forever_10_mins_discounted_40_alternative_${iapSuffix}`;
                    default: return `forever_10_mins_discounted_40_${iapSuffix}`;
                }
            }
            return `forever_10_mins_discounted_40_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapForever10MinsDiscounted45:
            return `forever_10_mins_discounted_45_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapForever10MinsDiscounted50:
            return `forever_10_mins_discounted_50_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapForever10MinsDiscounted80:
            return `forever_10_mins_discounted_80_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iap10MinsMonthly:
            if (platform === appPlatform_1.AppPlatform.Android) {
                switch (appType) {
                    case appType_1.AppType.int: return `subscription_monthly_curious_${iapSuffix}_${applePriceMatchSuffix}`;
                    case appType_1.AppType.lang_zhyue: return `subscription_monthly_10mins_alternative_${iapSuffix}`;
                    default: return `subscription_monthly_10mins_${iapSuffix}`;
                }
            }
            switch (appType) {
                case appType_1.AppType.local_hu:
                case appType_1.AppType.int:
                case appType_1.AppType.local_ar:
                    return `drops_topup_monthly_10mins_${iapSuffix}`;
                default: return `subscription_monthly_10mins_${iapSuffix}`;
            }
        case PayloadIAPIdentifierV4.iap10MinsYearly:
            if (platform === appPlatform_1.AppPlatform.Android) {
                switch (appType) {
                    case appType_1.AppType.int: return `subscription_yearly_10mins_${iapSuffix}_${applePriceMatchSuffix}`;
                    default: return `subscription_yearly_10mins_${iapSuffix}`;
                }
            }
            switch (appType) {
                case appType_1.AppType.local_hu:
                case appType_1.AppType.int:
                    return `drops_topup_yearly_10mins_${iapSuffix}`;
                default: return `subscription_yearly_10mins_${iapSuffix}`;
            }
        case PayloadIAPIdentifierV4.iapForever99Mins:
            if (platform === appPlatform_1.AppPlatform.Android) {
                return `forever_unlimited_time_${iapSuffix}`;
            }
            switch (appType) {
                case appType_1.AppType.local_hu: return 'drops_topup_forever_99mins_hu';
                case appType_1.AppType.int: return 'drops_topup_forever_99mins';
                default: return `forever_unlimited_time_${iapSuffix}`;
            }
        case PayloadIAPIdentifierV4.iapForever99MinsDiscounted:
            if (platform === appPlatform_1.AppPlatform.Android) {
                return `forever_unlimited_time_discounted_60_${iapSuffix}`;
            }
            switch (appType) {
                case appType_1.AppType.local_hu: return 'drops_topup_forever_99mins_discounted_hu';
                case appType_1.AppType.int: return 'drops_topup_forever_99mins_discounted';
                default: return `forever_unlimited_time_discounted_60_${iapSuffix}`;
            }
        case PayloadIAPIdentifierV4.iapForever99MinsDiscounted40:
            return `forever_unlimited_time_discounted_40_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapForever99MinsDiscounted45:
            return `forever_unlimited_time_discounted_45_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapForever99MinsDiscounted50:
            return `forever_unlimited_time_discounted_50_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapForever99MinsDiscounted80:
            return `forever_unlimited_time_discounted_80_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapUnlimitedMonthly:
            if (platform === appPlatform_1.AppPlatform.Android) {
                switch (appType) {
                    case appType_1.AppType.int: return `subscription_monthly_unliminted_time_${iapSuffix}_${applePriceMatchSuffix}`;
                    default: return `subscription_monthly_unliminted_time_${iapSuffix}`;
                }
            }
            else {
                return `subscription_monthly_unliminted_time_${iapSuffix}`;
            }
        case PayloadIAPIdentifierV4.iapUnlimitedYearly:
            if (platform === appPlatform_1.AppPlatform.Android) {
                switch (appType) {
                    case appType_1.AppType.int: return `subscription_yearly_unliminted_time_${iapSuffix}_${applePriceMatchSuffix}`;
                    default: return `subscription_yearly_unliminted_time_${iapSuffix}`;
                }
            }
            else {
                return `subscription_yearly_unliminted_time_${iapSuffix}`;
            }
        case PayloadIAPIdentifierV4.iapForeverAllLanguages:
            return `forever_all_languages_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapForeverAllLanguagesDiscounted:
            return `forever_all_languages_discounted_60_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapForeverAllLanguagesDiscounted40:
            return `forever_all_languages_discounted_40_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapForeverAllLanguagesDiscounted45:
            return `forever_all_languages_discounted_45_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapForeverAllLanguagesDiscounted50:
            return `forever_all_languages_discounted_50_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapForeverAllLanguagesDiscounted80:
            return `forever_all_languages_discounted_80_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapAllLanguagesMonthly:
            if (platform === appPlatform_1.AppPlatform.Android) {
                switch (appType) {
                    case appType_1.AppType.int: return `subscription_monthly_all_languages_${iapSuffix}_${applePriceMatchSuffix}`;
                    case appType_1.AppType.lang_zhyue: return `subscription_monthly_all_languages_alternative_${iapSuffix}`;
                    default: return `subscription_monthly_all_languages_${iapSuffix}`;
                }
            }
            else {
                return `subscription_monthly_all_languages_${iapSuffix}`;
            }
        case PayloadIAPIdentifierV4.iapAllLanguagesMonthlyFreeTrial:
            return `subscription_monthly_all_languages_trial_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapUnlimitedMonthlyFreeTrial:
            return `subscription_monthly_unliminted_time_trial_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapAllLanguagesYearly:
            if (platform === appPlatform_1.AppPlatform.Android) {
                switch (appType) {
                    case appType_1.AppType.int: return `subscription_yearly_all_languages_${iapSuffix}_${applePriceMatchSuffix}`;
                    default: return `subscription_yearly_all_languages_${iapSuffix}`;
                }
            }
            else {
                return `subscription_yearly_all_languages_${iapSuffix}`;
            }
        // simplified pricing model:
        case PayloadIAPIdentifierV4.iapPremiumLifetime160:
            if (appType === appType_1.AppType.local_zh && platform === appPlatform_1.AppPlatform.Android) {
                return `Drops premium lifetime`; // this is what we display on the AliPay checkout screen
            }
            else {
                return `premium_lifetime_160_${iapSuffix}_v2`;
            }
        case PayloadIAPIdentifierV4.iapPremiumLifetime180:
            return `premium_lifetime_180_${iapSuffix.replace('lang_', '')}_v2`;
        case PayloadIAPIdentifierV4.iapPremiumLifetime80:
            if (platform === appPlatform_1.AppPlatform.iOS) {
                return `forever_all_languages_discounted_80_${iapSuffix}`;
            }
            else {
                if (appType_1.AppType.isTier1App(appType)) {
                    return `premium_lifetime_80_${iapSuffix.replace('lang_', '')}_v2`;
                }
                else {
                    return `premium_lifetime_80_${iapSuffix}_v2`;
                }
            }
        case PayloadIAPIdentifierV4.iapPremiumLifetime55:
            if (platform === appPlatform_1.AppPlatform.Android) {
                if (appType_1.AppType.isTier1App(appType)) {
                    return `premium_lifetime_55_${iapSuffix.replace('lang_', '')}_v2`;
                }
                else {
                    return `premium_lifetime_55_${iapSuffix}_v2`;
                }
            }
            else {
                return `forever_all_languages_discounted_55_${iapSuffix}`;
            }
        case PayloadIAPIdentifierV4.iapPremiumLifetime55Plus1:
            return `premium_lifetime_55_plus1_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumLifetime65Plus1Year:
        case PayloadIAPIdentifierV4.iapPremiumLifetime65:
            if (platform === appPlatform_1.AppPlatform.Android) {
                return `premium_lifetime_65_${iapSuffix}_v2`;
            }
            else {
                return `forever_all_languages_discounted_60_${iapSuffix}`;
            }
        case PayloadIAPIdentifierV4.iapPremiumLifetime35:
            return `premium_lifetime_35_${iapSuffix}_v2`;
        case PayloadIAPIdentifierV4.iapPremiumYearly70:
            return `premium_yearly_70_${iapSuffix}_v2`;
        case PayloadIAPIdentifierV4.iapPremiumYearly70FreeTrial:
            if (appType === appType_1.AppType.lang_enus && platform === appPlatform_1.AppPlatform.iOS) {
                return `premium_yearly_70_freetrial_lang_enus_v2`;
            }
            return `premium_yearly_70_freetrial_${iapSuffix}_v2`;
        case PayloadIAPIdentifierV4.iapPremiumYearly70FreeTrial3Days:
            return `premium_yearly_70_freetrial_3days_${iapSuffix}_v2`;
        case PayloadIAPIdentifierV4.iapPremiumYearly70FreeTrial14Days:
            return `premium_yearly_70_freetrial_14days_${iapSuffix}_v2`;
        case PayloadIAPIdentifierV4.iapPremiumYearly55:
            return `premium_yearly_55_${iapSuffix}_v3`;
        case PayloadIAPIdentifierV4.iapPremiumYearly50:
            return `premium_yearly_50_${iapSuffix}_v3`;
        case PayloadIAPIdentifierV4.iapPremiumYearly45:
            return `premium_yearly_45_${iapSuffix.replace('lang_', '')}_v2`;
        case PayloadIAPIdentifierV4.iapPremiumYearly40FirstYear15:
            if (platform === appPlatform_1.AppPlatform.Android) {
                return `premium_yearly_40_first_year_15_${iapSuffix}_v2`;
            }
            else {
                return `subscription_yearly_unliminted_time_${iapSuffix}`;
            }
        case PayloadIAPIdentifierV4.iapPremiumYearly40FirstYear30Plus1:
        case PayloadIAPIdentifierV4.iapPremiumYearly40FirstYear30:
            if (platform === appPlatform_1.AppPlatform.Android) {
                return `premium_yearly_40_first_year_30_${iapSuffix}_v2`;
            }
            else {
                return `premium_yearly_40_freetrial_${iapSuffix}_v3`;
            }
        case PayloadIAPIdentifierV4.iapPremiumYearly40Plus1:
        case PayloadIAPIdentifierV4.iapPremiumYearly40:
            return `premium_yearly_40_${iapSuffix}_v2`;
        case PayloadIAPIdentifierV4.iapPremiumYearly40FreeTrial:
            return `premium_yearly_40_freetrial_${iapSuffix}_v3`;
        case PayloadIAPIdentifierV4.iapPremiumYearly35:
            return `premium_yearly_35_${iapSuffix}_v2`;
        case PayloadIAPIdentifierV4.iapPremiumYearly30:
            return `premium_yearly_30_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearly25:
            return `premium_yearly_25_${iapSuffix.replace('lang_', '')}_v2`;
        case PayloadIAPIdentifierV4.iapPremiumYearly15:
            return `premium_yearly_15_${iapSuffix}_v2`;
        case PayloadIAPIdentifierV4.iapPremiumQuarterly30:
            return `premium_quarterly_30_${iapSuffix}_v3`;
        case PayloadIAPIdentifierV4.iapPremiumMonthly10:
            return `premium_monthly_10_${iapSuffix}_v2`;
        case PayloadIAPIdentifierV4.iapPremiumMonthly13:
            return `premium_monthly_13_${iapSuffix.replace('lang_', '')}_v2`;
        case PayloadIAPIdentifierV4.iapPremiumMonthly15:
            return `premium_monthly_15_${iapSuffix}_v2`;
        case PayloadIAPIdentifierV4.iapPremiumMonthly3:
            return `premium_monthly_3_${iapSuffix}_v2`;
        case PayloadIAPIdentifierV4.iapPremium1year40:
            if (appType === appType_1.AppType.local_zh && platform === appPlatform_1.AppPlatform.Android) {
                return `Drops premium 1 year - 40% discount`; // this is what we display on the AliPay checkout screen
            }
            else {
                return ``;
            }
        case PayloadIAPIdentifierV4.iapPremium1year70:
            if (appType === appType_1.AppType.local_zh && platform === appPlatform_1.AppPlatform.Android) {
                return `Drops premium 1 year`; // this is what we display on the AliPay checkout screen
            }
            else {
                return ``;
            }
        case PayloadIAPIdentifierV4.iapPremium3months30:
            if (appType === appType_1.AppType.local_zh && platform === appPlatform_1.AppPlatform.Android) {
                return `Drops premium 3 months`; // this is what we display on the AliPay checkout screen
            }
            else {
                return ``;
            }
        case PayloadIAPIdentifierV4.iapPremiumWeekly3:
            return `premium_weekly_3_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumWeekly5:
            return `premium_weekly_5_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumWeekly7:
            return `premium_weekly_7_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearly36FreeTrial7days:
            return `premium_yearly_36_free_trial_7_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearly42FreeTrial7days:
            return `premium_yearly_42_free_trial_7_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearly48FreeTrial7days:
            return `premium_yearly_48_free_trial_7_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearly54FreeTrial7days:
            return `premium_yearly_54_free_trial_7_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearly56FreeTrial7days:
            return `premium_yearly_56_free_trial_7_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearly60FreeTrial7days:
            return `premium_yearly_60_free_trial_7_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearly64FreeTrial7days:
            return `premium_yearly_64_free_trial_7_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearly70FreeTrial7days:
            return `premium_yearly_70_free_trial_7_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearly72FreeTrial7days:
            return `premium_yearly_72_free_trial_7_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearly80FreeTrial7days:
            return `premium_yearly_80_free_trial_7_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearly90FreeTrial7days:
            if (platform === appPlatform_1.AppPlatform.Android) {
                return `premium_yearly_90_free_trial_7${iapSuffix}_v2`;
            }
            else {
                return `premium_yearly_90_free_trial_7${iapSuffix}`;
            }
        case PayloadIAPIdentifierV4.iapPremiumYearly36:
            return `premium_yearly_36_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearly42:
            return `premium_yearly_42_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearly48:
            return `premium_yearly_48_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearly54:
            return `premium_yearly_54_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearly56:
            return `premium_yearly_56_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearly64:
            return `premium_yearly_64_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearly72:
            return `premium_yearly_72_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearly60:
            return `premium_yearly_60_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearly80:
            return `premium_yearly_80_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearly90:
            return `premium_yearly_90_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremium6Monthly40:
            return `premium_halfyear_40_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumQuarterly20:
            return `premium_quarterly_20_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearlyEducation:
        case PayloadIAPIdentifierV4.iapPremiumYearlyKahootPlus:
        case PayloadIAPIdentifierV4.iapPremiumGift1Year35:
        case PayloadIAPIdentifierV4.iapPremiumGift1Month10:
        case PayloadIAPIdentifierV4.iapPremiumGiftLifetime160:
        case PayloadIAPIdentifierV4.iapPremiumLifetime90:
        case PayloadIAPIdentifierV4.iapPremiumLifetimeKahootPlus:
        case PayloadIAPIdentifierV4.iapPremium2Weekly19FreeTrial7Days:
        case PayloadIAPIdentifierV4.iapPremium2Weekly26FreeTrial7Days:
        case PayloadIAPIdentifierV4.iapPremiumOneYearISIC:
        case PayloadIAPIdentifierV4.iapPremiumOneYearErasmus:
            return '';
        // SEGMENTED PRICING
        case PayloadIAPIdentifierV4.iapPremiumYearlyFullPrice:
            return `premium_yearly_full_price_${PriceTier.getPriceTierSuffix(tier)}_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearlyFullPriceFreeTrial:
            return `premium_yearly_full_price_${PriceTier.getPriceTierSuffix(tier)}_free_trial_7_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearlyFullPriceFreeTrial14Days:
            return `premium_yearly_full_price_${PriceTier.getPriceTierSuffix(tier)}_free_trial_14_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumMonthlyFullPrice:
            return `premium_monthly_full_price_${PriceTier.getPriceTierSuffix(tier)}_${iapSuffix}_v2`;
        case PayloadIAPIdentifierV4.iapPremiumQuarterlyFullPrice:
            return `premium_quarterly_full_price_${PriceTier.getPriceTierSuffix(tier)}_${iapSuffix}_v2`;
        case PayloadIAPIdentifierV4.iapPremiumLifetimeFullPrice:
            return `premium_lifetime_full_price_${PriceTier.getPriceTierSuffix(tier)}_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearlyDiscount20:
            return `premium_yearly_discount_20_${PriceTier.getPriceTierSuffix(tier)}_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearlyDiscount40:
            return `premium_yearly_discount_40_${PriceTier.getPriceTierSuffix(tier)}_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount40:
            return `premium_lifetime_discount_40_${PriceTier.getPriceTierSuffix(tier)}_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearlyDiscount45:
            return `premium_yearly_discount_45_${PriceTier.getPriceTierSuffix(tier)}_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount45:
            return `premium_lifetime_discount_45_${PriceTier.getPriceTierSuffix(tier)}_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearlyDiscount50:
            return `premium_yearly_discount_50_${PriceTier.getPriceTierSuffix(tier)}_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount50:
            return `premium_lifetime_discount_50_${PriceTier.getPriceTierSuffix(tier)}_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearlyDiscount55:
            return `premium_yearly_discount_55_${PriceTier.getPriceTierSuffix(tier)}_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount55:
            return `premium_lifetime_discount_55_${PriceTier.getPriceTierSuffix(tier)}_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearlyDiscount60:
            return `premium_yearly_discount_60_${PriceTier.getPriceTierSuffix(tier)}_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount60:
            return `premium_lifetime_discount_60_${PriceTier.getPriceTierSuffix(tier)}_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumYearlyDiscount65:
            return `premium_yearly_discount_65_${PriceTier.getPriceTierSuffix(tier)}_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount65:
            return `premium_lifetime_discount_65_${PriceTier.getPriceTierSuffix(tier)}_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount45BOGO:
            return `premium_lifetime_discount_45_bogo_${PriceTier.getPriceTierSuffix(tier)}_${iapSuffix}`;
        case PayloadIAPIdentifierV4.iapFreePremium2WeeksReferrals:
            return `rc_promo_free-premium_weekly`;
    }
};
const getAlternativeProductIdsMobileUtils = (identifier, platform, appType) => {
    const iapSuffix = appType_1.AppType.getIapSuffix(appType, platform);
    switch (identifier) {
        case PayloadIAPIdentifierV4.iapForever10MinsDiscounted40:
            return [`forever_10_mins_discounted_40_${iapSuffix}`];
        case PayloadIAPIdentifierV4.iapForever10Mins:
            return platform === appPlatform_1.AppPlatform.iOS ? ['forever5Mins'] : [];
        case PayloadIAPIdentifierV4.iapForever10MinsDiscounted:
            return platform === appPlatform_1.AppPlatform.iOS ? ['forever10MinsDiscounted'] : [];
        case PayloadIAPIdentifierV4.iapForever10MinsDiscounted80:
        case PayloadIAPIdentifierV4.iapForever10MinsDiscounted45:
        case PayloadIAPIdentifierV4.iapForever10MinsDiscounted50:
            return [];
        case PayloadIAPIdentifierV4.iap10MinsMonthly:
            return platform === appPlatform_1.AppPlatform.Android ? [`subscription_monthly_curious_${iapSuffix}`, 'subscription_monthly_10mins_int_cis_30', 'subscription_monthly_10mins_int_cis_50'] : [];
        case PayloadIAPIdentifierV4.iap10MinsYearly:
            return platform === appPlatform_1.AppPlatform.Android ? [`subscription_yearly_10mins_${iapSuffix}`, 'subscription_yearly_10mins_int_cis_30', 'subscription_yearly_10mins_int_cis_50'] : [];
        case PayloadIAPIdentifierV4.iapForever99Mins:
            return platform === appPlatform_1.AppPlatform.iOS ? ['forever99Mins'] : [];
        case PayloadIAPIdentifierV4.iapForever99MinsDiscounted:
            return platform === appPlatform_1.AppPlatform.iOS ? ['forever99MinsDiscounted'] : [];
        case PayloadIAPIdentifierV4.iapForever99MinsDiscounted40:
        case PayloadIAPIdentifierV4.iapForever99MinsDiscounted80:
        case PayloadIAPIdentifierV4.iapForever99MinsDiscounted45:
        case PayloadIAPIdentifierV4.iapForever99MinsDiscounted50:
            return [];
        case PayloadIAPIdentifierV4.iapUnlimitedMonthly:
            if (platform === appPlatform_1.AppPlatform.Android) {
                return [`subscription_monthly_unliminted_time_${iapSuffix}`, 'subscription_monthly_unliminted_time_int_cis_30', 'subscription_monthly_unliminted_time_int_cis_50'];
            }
            else {
                if ([appType_1.AppType.lang_he, appType_1.AppType.lang_ar, appType_1.AppType.lang_ja, appType_1.AppType.lang_tl].includes(appType)) {
                    return [`subscription_monthly_unliminted_time_trial_${iapSuffix}`];
                }
                else {
                    return [];
                }
            }
        case PayloadIAPIdentifierV4.iapUnlimitedYearly:
            return platform === appPlatform_1.AppPlatform.Android ? [`subscription_yearly_unliminted_time_${iapSuffix}`, 'subscription_yearly_unliminted_time_int_cis_30', 'subscription_yearly_unliminted_time_int_cis_50'] : [];
        case PayloadIAPIdentifierV4.iapForeverAllLanguages:
        case PayloadIAPIdentifierV4.iapForeverAllLanguagesDiscounted:
        case PayloadIAPIdentifierV4.iapForeverAllLanguagesDiscounted40:
        case PayloadIAPIdentifierV4.iapForeverAllLanguagesDiscounted80:
        case PayloadIAPIdentifierV4.iapForeverAllLanguagesDiscounted45:
        case PayloadIAPIdentifierV4.iapForeverAllLanguagesDiscounted50:
            return [];
        case PayloadIAPIdentifierV4.iapAllLanguagesMonthly:
            return platform === appPlatform_1.AppPlatform.Android ? [`subscription_monthly_all_languages_${iapSuffix}`, 'subscription_monthly_all_languages_int_cis_30', 'subscription_monthly_all_languages_int_cis_50'] : [];
        case PayloadIAPIdentifierV4.iapAllLanguagesMonthlyFreeTrial:
            return [];
        case PayloadIAPIdentifierV4.iapUnlimitedMonthlyFreeTrial:
            return [];
        case PayloadIAPIdentifierV4.iapAllLanguagesYearly:
            return platform === appPlatform_1.AppPlatform.Android ? [`subscription_yearly_all_languages_${iapSuffix}`, 'subscription_yearly_all_languages_int_cis_30', 'subscription_yearly_all_languages_int_cis_50'] : [];
        case PayloadIAPIdentifierV4.iapPremiumLifetime35:
        case PayloadIAPIdentifierV4.iapPremiumLifetime55:
        case PayloadIAPIdentifierV4.iapPremiumLifetime55Plus1:
        case PayloadIAPIdentifierV4.iapPremiumLifetime65:
        case PayloadIAPIdentifierV4.iapPremiumLifetime65Plus1Year:
        case PayloadIAPIdentifierV4.iapPremiumLifetime80:
        case PayloadIAPIdentifierV4.iapPremiumLifetime90:
        case PayloadIAPIdentifierV4.iapPremiumLifetime160:
        case PayloadIAPIdentifierV4.iapPremiumLifetime180:
        case PayloadIAPIdentifierV4.iapPremiumYearly70:
        case PayloadIAPIdentifierV4.iapPremiumYearly35:
        case PayloadIAPIdentifierV4.iapPremiumYearly30:
        case PayloadIAPIdentifierV4.iapPremiumYearly25:
        case PayloadIAPIdentifierV4.iapPremiumYearly15:
        case PayloadIAPIdentifierV4.iapPremiumYearlyEducation:
        case PayloadIAPIdentifierV4.iapPremiumYearlyKahootPlus:
        case PayloadIAPIdentifierV4.iapPremiumOneYearISIC:
        case PayloadIAPIdentifierV4.iapPremiumOneYearErasmus:
        case PayloadIAPIdentifierV4.iapPremiumYearly40:
        case PayloadIAPIdentifierV4.iapPremiumYearly40FreeTrial:
        case PayloadIAPIdentifierV4.iapPremiumYearly36FreeTrial7days:
        case PayloadIAPIdentifierV4.iapPremiumYearly42FreeTrial7days:
        case PayloadIAPIdentifierV4.iapPremiumYearly48FreeTrial7days:
        case PayloadIAPIdentifierV4.iapPremiumYearly54FreeTrial7days:
        case PayloadIAPIdentifierV4.iapPremiumYearly56FreeTrial7days:
        case PayloadIAPIdentifierV4.iapPremiumYearly60FreeTrial7days:
        case PayloadIAPIdentifierV4.iapPremiumYearly64FreeTrial7days:
        case PayloadIAPIdentifierV4.iapPremiumYearly70FreeTrial3Days:
        case PayloadIAPIdentifierV4.iapPremiumYearly70FreeTrial7days:
        case PayloadIAPIdentifierV4.iapPremiumYearly72FreeTrial7days:
        case PayloadIAPIdentifierV4.iapPremiumYearly70FreeTrial14Days:
        case PayloadIAPIdentifierV4.iapPremiumYearly80FreeTrial7days:
        case PayloadIAPIdentifierV4.iapPremiumYearly90FreeTrial7days:
        case PayloadIAPIdentifierV4.iapPremiumYearly40Plus1:
        case PayloadIAPIdentifierV4.iapPremiumYearly40FirstYear15:
        case PayloadIAPIdentifierV4.iapPremiumYearly40FirstYear30:
        case PayloadIAPIdentifierV4.iapPremiumYearly40FirstYear30Plus1:
        case PayloadIAPIdentifierV4.iapPremiumYearly36:
        case PayloadIAPIdentifierV4.iapPremiumYearly42:
        case PayloadIAPIdentifierV4.iapPremiumYearly48:
        case PayloadIAPIdentifierV4.iapPremiumYearly54:
        case PayloadIAPIdentifierV4.iapPremiumYearly56:
        case PayloadIAPIdentifierV4.iapPremiumYearly64:
        case PayloadIAPIdentifierV4.iapPremiumYearly72:
        case PayloadIAPIdentifierV4.iapPremiumYearly45:
        case PayloadIAPIdentifierV4.iapPremiumYearly50:
        case PayloadIAPIdentifierV4.iapPremiumYearly55:
        case PayloadIAPIdentifierV4.iapPremiumYearly60:
        case PayloadIAPIdentifierV4.iapPremiumYearly80:
        case PayloadIAPIdentifierV4.iapPremiumYearly90:
        case PayloadIAPIdentifierV4.iapPremium6Monthly40:
        case PayloadIAPIdentifierV4.iapPremiumQuarterly30:
        case PayloadIAPIdentifierV4.iapPremiumQuarterly20:
        case PayloadIAPIdentifierV4.iapPremiumMonthly3:
        case PayloadIAPIdentifierV4.iapPremiumMonthly10:
        case PayloadIAPIdentifierV4.iapPremiumMonthly13:
        case PayloadIAPIdentifierV4.iapPremiumMonthly15:
        case PayloadIAPIdentifierV4.iapPremiumWeekly3:
        case PayloadIAPIdentifierV4.iapPremiumWeekly5:
        case PayloadIAPIdentifierV4.iapPremiumWeekly7:
        case PayloadIAPIdentifierV4.iapPremium2Weekly19FreeTrial7Days:
        case PayloadIAPIdentifierV4.iapPremium2Weekly26FreeTrial7Days:
        case PayloadIAPIdentifierV4.iapPremiumGift1Year35:
        case PayloadIAPIdentifierV4.iapPremiumGift1Month10:
        case PayloadIAPIdentifierV4.iapPremiumGiftLifetime160:
        case PayloadIAPIdentifierV4.iapPremiumLifetimeKahootPlus:
        case PayloadIAPIdentifierV4.iapPremiumYearlyFullPrice:
        case PayloadIAPIdentifierV4.iapPremiumYearlyFullPriceFreeTrial:
        case PayloadIAPIdentifierV4.iapPremiumYearlyFullPriceFreeTrial14Days:
        case PayloadIAPIdentifierV4.iapPremiumMonthlyFullPrice:
        case PayloadIAPIdentifierV4.iapPremiumQuarterlyFullPrice:
        case PayloadIAPIdentifierV4.iapPremiumLifetimeFullPrice:
        case PayloadIAPIdentifierV4.iapPremiumYearlyDiscount20:
        case PayloadIAPIdentifierV4.iapPremiumYearlyDiscount40:
        case PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount40:
        case PayloadIAPIdentifierV4.iapPremiumYearlyDiscount45:
        case PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount45:
        case PayloadIAPIdentifierV4.iapPremiumYearlyDiscount50:
        case PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount50:
        case PayloadIAPIdentifierV4.iapPremiumYearlyDiscount55:
        case PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount55:
        case PayloadIAPIdentifierV4.iapPremiumYearlyDiscount60:
        case PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount60:
        case PayloadIAPIdentifierV4.iapPremiumYearlyDiscount65:
        case PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount65:
        case PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount45BOGO:
            return [];
        case PayloadIAPIdentifierV4.iapPremiumYearly70FreeTrial:
            return language_1.LanguageISO.all
                .map((iso) => `premium_yearly_70_freetrial_${iso.toLowerCase()}_${iapSuffix}_v2`);
        case PayloadIAPIdentifierV4.iapPremium1year70:
        case PayloadIAPIdentifierV4.iapPremium1year40:
        case PayloadIAPIdentifierV4.iapPremium3months30:
            return [];
        case PayloadIAPIdentifierV4.iapFreePremium2WeeksReferrals:
            return [];
    }
};
exports.getAlternativeProductIdsMobileUtils = getAlternativeProductIdsMobileUtils;
(function (PayloadIAPIdentifierV4) {
    PayloadIAPIdentifierV4.all = Object.values(PayloadIAPIdentifierV4).filter((v) => typeof v === 'string');
    PayloadIAPIdentifierV4.getProductId = exports.getProductIdUtils;
    PayloadIAPIdentifierV4.getAlternativeProductIdsMobile = exports.getAlternativeProductIdsMobileUtils;
    const hasGiftMap = {
        [PayloadIAPIdentifierV4.iapPremiumMonthly10]: false,
        [PayloadIAPIdentifierV4.iapPremiumMonthly13]: false,
        [PayloadIAPIdentifierV4.iapPremiumMonthly15]: false,
        [PayloadIAPIdentifierV4.iapPremiumQuarterly30]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly70]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly70FreeTrial]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly70FreeTrial3Days]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly70FreeTrial14Days]: false,
        [PayloadIAPIdentifierV4.iapPremiumLifetime160]: false,
        [PayloadIAPIdentifierV4.iapPremiumLifetime180]: false,
        [PayloadIAPIdentifierV4.iapPremium3months30]: false,
        [PayloadIAPIdentifierV4.iapPremium1year70]: false,
        [PayloadIAPIdentifierV4.iapPremiumGift1Month10]: false,
        [PayloadIAPIdentifierV4.iapPremiumGiftLifetime160]: false,
        [PayloadIAPIdentifierV4.iap10MinsMonthly]: false,
        [PayloadIAPIdentifierV4.iap10MinsYearly]: false,
        [PayloadIAPIdentifierV4.iapForever10Mins]: false,
        [PayloadIAPIdentifierV4.iapUnlimitedMonthly]: false,
        [PayloadIAPIdentifierV4.iapUnlimitedMonthlyFreeTrial]: false,
        [PayloadIAPIdentifierV4.iapUnlimitedYearly]: false,
        [PayloadIAPIdentifierV4.iapForever99Mins]: false,
        [PayloadIAPIdentifierV4.iapAllLanguagesMonthly]: false,
        [PayloadIAPIdentifierV4.iapAllLanguagesMonthlyFreeTrial]: false,
        [PayloadIAPIdentifierV4.iapAllLanguagesYearly]: false,
        [PayloadIAPIdentifierV4.iapForeverAllLanguages]: false,
        [PayloadIAPIdentifierV4.iapPremiumMonthly3]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly15]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly25]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly30]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly35]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly40]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly40FreeTrial]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly40FirstYear15]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly40FirstYear30]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly45]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly50]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly55]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearlyEducation]: false,
        [PayloadIAPIdentifierV4.iapPremiumOneYearISIC]: false,
        [PayloadIAPIdentifierV4.iapPremiumOneYearErasmus]: false,
        [PayloadIAPIdentifierV4.iapPremiumLifetime35]: false,
        [PayloadIAPIdentifierV4.iapPremiumLifetime55]: false,
        [PayloadIAPIdentifierV4.iapPremiumLifetime65]: false,
        [PayloadIAPIdentifierV4.iapPremiumLifetime80]: false,
        [PayloadIAPIdentifierV4.iapPremiumLifetime90]: false,
        [PayloadIAPIdentifierV4.iapPremium1year40]: false,
        [PayloadIAPIdentifierV4.iapPremiumGift1Year35]: false,
        [PayloadIAPIdentifierV4.iapForever10MinsDiscounted]: false,
        [PayloadIAPIdentifierV4.iapForever10MinsDiscounted40]: false,
        [PayloadIAPIdentifierV4.iapForever10MinsDiscounted45]: false,
        [PayloadIAPIdentifierV4.iapForever10MinsDiscounted50]: false,
        [PayloadIAPIdentifierV4.iapForever10MinsDiscounted80]: false,
        [PayloadIAPIdentifierV4.iapForever99MinsDiscounted]: false,
        [PayloadIAPIdentifierV4.iapForever99MinsDiscounted40]: false,
        [PayloadIAPIdentifierV4.iapForever99MinsDiscounted45]: false,
        [PayloadIAPIdentifierV4.iapForever99MinsDiscounted50]: false,
        [PayloadIAPIdentifierV4.iapForever99MinsDiscounted80]: false,
        [PayloadIAPIdentifierV4.iapForeverAllLanguagesDiscounted]: false,
        [PayloadIAPIdentifierV4.iapForeverAllLanguagesDiscounted40]: false,
        [PayloadIAPIdentifierV4.iapForeverAllLanguagesDiscounted45]: false,
        [PayloadIAPIdentifierV4.iapForeverAllLanguagesDiscounted50]: false,
        [PayloadIAPIdentifierV4.iapForeverAllLanguagesDiscounted80]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearlyKahootPlus]: false,
        [PayloadIAPIdentifierV4.iapPremiumLifetimeKahootPlus]: false,
        [PayloadIAPIdentifierV4.iapPremiumWeekly3]: false,
        [PayloadIAPIdentifierV4.iapPremiumWeekly5]: false,
        [PayloadIAPIdentifierV4.iapPremiumWeekly7]: false,
        [PayloadIAPIdentifierV4.iapPremiumQuarterly20]: false,
        [PayloadIAPIdentifierV4.iapPremium6Monthly40]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly90FreeTrial7days]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly60]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly90]: false,
        [PayloadIAPIdentifierV4.iapPremium2Weekly19FreeTrial7Days]: false,
        [PayloadIAPIdentifierV4.iapPremium2Weekly26FreeTrial7Days]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly36FreeTrial7days]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly42FreeTrial7days]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly48FreeTrial7days]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly54FreeTrial7days]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly56FreeTrial7days]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly60FreeTrial7days]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly64FreeTrial7days]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly70FreeTrial7days]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly72FreeTrial7days]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly80FreeTrial7days]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly36]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly42]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly48]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly54]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly56]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly60]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly64]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly70]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly72]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearly80]: false,
        [PayloadIAPIdentifierV4.iapPremiumLifetimeFullPrice]: false,
        [PayloadIAPIdentifierV4.iapPremiumQuarterlyFullPrice]: false,
        [PayloadIAPIdentifierV4.iapPremiumMonthlyFullPrice]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearlyFullPrice]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearlyFullPriceFreeTrial]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearlyFullPriceFreeTrial14Days]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearlyDiscount20]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearlyDiscount40]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearlyDiscount45]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearlyDiscount50]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearlyDiscount55]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearlyDiscount60]: false,
        [PayloadIAPIdentifierV4.iapPremiumYearlyDiscount65]: false,
        [PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount40]: false,
        [PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount45]: false,
        [PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount50]: false,
        [PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount55]: false,
        [PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount60]: false,
        [PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount65]: false,
        [PayloadIAPIdentifierV4.iapFreePremium2WeeksReferrals]: false,
        // with gift (BOGO)
        [PayloadIAPIdentifierV4.iapPremiumYearly40Plus1]: true,
        [PayloadIAPIdentifierV4.iapPremiumYearly40FirstYear30Plus1]: true,
        [PayloadIAPIdentifierV4.iapPremiumLifetime65Plus1Year]: true,
        [PayloadIAPIdentifierV4.iapPremiumLifetime55Plus1]: true,
        [PayloadIAPIdentifierV4.iapPremiumLifetimeDiscount45BOGO]: true,
    };
    PayloadIAPIdentifierV4.hasGift = (topUpId) => hasGiftMap[topUpId];
})(PayloadIAPIdentifierV4 = exports.PayloadIAPIdentifierV4 || (exports.PayloadIAPIdentifierV4 = {}));
